import {useSelector} from "react-redux";
import {IStore} from "../../slices/types/Store";

export const useUsers = (): any => {
  return useSelector((state: IStore) => state.global.users);
};
